if (typeof window.postMessage === 'undefined') {
  throw new Error('The Flat Embed JS API is not supported in this browser');
}
